import { deleteCameraSystem } from "actions/Utilities/CameraSystem";
import { toast } from "components/toastNotification";
import React from "react";
import { useRecoilState } from "recoil";
import { cameraSystemReFetching } from "../atoms/atoms";
import { useMutation } from "react-query";

export default function useDeleteCameraSystem() {
  const [isReFetching, setIsReFetching] = useRecoilState(
    cameraSystemReFetching
  );

  const { mutate } = useMutation((ids: number[]) => deleteCameraSystem(ids), {
    onSuccess: (res: any) => {
      if (typeof res == "object") {
        toast.fire("Disabling Camera System failed", res.Message, "error");
      } else {
        switch (true) {
          case res == "Success":
            toast.fire(
              "Success",
              "Camera System Disabled Successfully",
              "success"
            );
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `Camera System Disabled Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Disabling Camera System failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "Camera System not found":
            toast.fire(
              "Disabling Camera System failed ",
              `Error: ${res}`,
              "error"
            );
            break;
          default:
            toast.fire("Disabling Camera System failed", res, "error");
        }
      }
      // ReFetch Data
      setIsReFetching(isReFetching ? false : true);
    },
    onError: (error) => {
      toast.fire("Disabling Camera System failed", `Error: ${error}`, "error");
    },
  });

  return mutate;
}
